// extracted by mini-css-extract-plugin
export default {"container":"GH1laE","header":"yAvnVV","fixed":"Xni1xR","zeroHeight":"CQkaAH","inFrontOfCookieBanner":"RURRPw","signUpButtonContainer":"wS0NFa","signUpButton":"gmZRqr"};